const API_URL = process.env.REACT_APP_SERVER_BASE_URL || 'https://server-1rbv.onrender.com';

export const emailService = {
  sendWelcomeEmail: async (userEmail, userName) => {
    try {
      const response = await fetch(`${API_URL}/api/email/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'welcome',
          to: userEmail,
          data: {
            name: userName || 'User',
          },
        }),
      });
      if (!response.ok) {
        console.error('Failed to send welcome email:', await response.text());
      }
    } catch (error) {
      console.error('Error sending welcome email:', error);
    }
  },

  sendTestCompleteEmail: async (userEmail, userName, testData) => {
    try {
      const response = await fetch(`${API_URL}/api/email/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'test_complete',
          to: userEmail,
          data: {
            name: userName || 'User',
            ...testData
          },
        }),
      });
      if (!response.ok) {
        console.error('Failed to send test complete email:', await response.text());
      }
    } catch (error) {
      console.error('Error sending test complete email:', error);
    }
  }
};
